import { ErrorMessages } from "../../constants/ErrorMessages";
import { ValidationClasses } from "../enums/ValidationClasses";

const numbers: RegExp = /[0-9]/;
const uppercase: RegExp = /[A-Z]/;
const lowercase: RegExp = /[a-z]/;

export const PasswordPolicy: IPasswordPolicy = {
    minLength: 8,
    require: {
        numbers: (input: string) => numbers.test(input),
        uppercase: (input: string) => uppercase.test(input),
        lowercase: (input: string) => lowercase.test(input)
    }
}

export const EmailDomain: string = "@bayer.com"
export const ValidateEmail = (email: string): IFieldValidation => {
    let validation: IFieldValidation = { class: 'valid', message: '' };
    email = email?.trim();
    const regexp = new RegExp(/\s/);
    if (!email) {
        validation = { class: '', message: '' }
    }
    else if (regexp.test(email)) {
        validation = { class: ValidationClasses.INVALID, message: ErrorMessages.NO_WHITESPACE() }
    }
    else if (email?.indexOf(EmailDomain) === 0) {
        validation = { class: ValidationClasses.INVALID, message: ErrorMessages.JUST_DOMAIN() }
    }
    else if (!email?.toLowerCase()?.endsWith(EmailDomain)) {
        validation = { class: ValidationClasses.INVALID, message: ErrorMessages.WRONG_DOMAIN(EmailDomain) }
    }

    return validation;
}

export const ValidatePassword = (password: string): IFieldValidation => {
    let validation: IFieldValidation = { class: ValidationClasses.VALID, message: '' }
    if (!password) {
        validation = { class: '', message: '' }
    }
    else {
        if (password.length < PasswordPolicy.minLength) {
            validation = { class: ValidationClasses.INVALID, message: ErrorMessages.INVALID_PASSWORD_LENGTH(PasswordPolicy.minLength) }
        }
        else if (PasswordPolicy.require.lowercase && !PasswordPolicy.require.lowercase(password)) {
            validation = { class: ValidationClasses.INVALID, message: ErrorMessages.PASSWORD_LOWERCASE_REQUIRED() }
        }
        else if (PasswordPolicy.require.uppercase && !PasswordPolicy.require.uppercase(password)) {
            validation = { class: ValidationClasses.INVALID, message: ErrorMessages.PASSWORD_UPPERCASE_REQUIRED() }
        }
        else if (PasswordPolicy.require.numbers && !PasswordPolicy.require.numbers(password)) {
            validation = { class: ValidationClasses.INVALID, message: ErrorMessages.PASSWORD_NUMBER_REQUIRED() }
        }
    }
    return validation;
}
